import React from 'react';
import Chip from '@mui/material/Chip';
import Link from './Link';
import { IEntity, CEntity, CLabel, CMapLabel } from '@ts/ui-models';
import { Icon } from '@ts/storybook';

//const useStyles = makeStyles((theme: Theme) => ({}));

interface ChipEntityProps {
  entity: CEntity<IEntity>;
  onClick?: () => void;
}

const ChipEntity: React.FC<ChipEntityProps> = props => {
  const { entity, onClick } = props;
  const isLabel = entity instanceof CLabel || entity instanceof CMapLabel;
  const icon = entity.getIcon();
  return (
    <Link key={'link-' + entity.getID()} onClick={onClick} entity={entity}>
      <Chip
        key={'chip-' + entity.getID()}
        sx={{
          maxWidth: '240px',
          margin: '0.25rem',
          borderRadius: '5px!important',
          cursor: 'pointer',
          ...(isLabel && { backgroundColor: `${(entity as CLabel).color}50` }),
          '&:hover': {
            backgroundColor: 'rgba(0, 60, 136, 0.5)',
          },
        }}
        label={entity.getName()}
        avatar={icon ? <Icon size={18} icon={icon} sx={{ paddingLeft: '2px' }} /> : undefined}
        variant="outlined"
        size="small"
      />
    </Link>
  );
};

export default ChipEntity;
